import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlTree,
} from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { withCurrentLocale } from '../services/utils/keycloak-locale';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(
    private keycloakService: KeycloakService,
    private router: Router
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    const requiredRoles = route.data['roles'] as string[];

    if (!requiredRoles || requiredRoles.length === 0) {
      return true;
    }

    try {
      const isLoggedIn = await this.keycloakService.isLoggedIn();

      if (!isLoggedIn) {
        // Sauvegarder l'URL demandée pour rediriger après login
        await this.keycloakService.login(withCurrentLocale({
          redirectUri: window.location.origin + state.url,
        }));
        return false;
      }

      // ✅ getUserRoles() est SYNCHRONE, pas besoin de await
      const userRoles = this.keycloakService.getUserRoles(true);

      // L'une des exigences suffit. Une exigence « à point » est une permission
      // (sessions.inspect, registrations.read) : le superviseur les passe
      // toutes, par décision — mais pas un rôle (student), qui dit un espace.
      const hasRole = requiredRoles.some((role) => userRoles.includes(role))
        || (userRoles.includes('supervisor') && requiredRoles.some((r) => r.includes('.')));

      // ✅ Log corrigé pour afficher les bonnes informations
      /*console.log('RoleGuard Check:', {
        url: state.url,
        userRoles: userRoles,
        requiredRoles: requiredRoles,
        hasAccess: hasRole,
      });*/

      if (!hasRole) {
        //console.warn('Access denied - User does not have required role');
        return this.router.parseUrl('/unauthorized');
      }

      return true;
    } catch (error) {
      //console.error('RoleGuard error:', error);
      return this.router.parseUrl('/unauthorized');
    }
  }
}
